// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-status-panel',
    // #endregion
    // #region Properties
    props: {
        statusCode: {
            type: Number,
            default: 0
        },
        statusProperties: {
            type: Object,
            required: false,
            default: {}
        }
    },
    // #endregion
});
// #endregion
